import script from "./CreateAlertsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAlertsView.vue?vue&type=script&setup=true&lang=ts"

import "./CreateAlertsView.vue?vue&type=style&index=0&id=2daa0ffc&lang=scss"

const __exports__ = script;

export default __exports__